export const UPDATE_CARD_COUNT_URL = '/updateCardCount';
